import http from '@/http'
const URL = '/admin/partners'

export const list = async (params) => {
  const list = (await http.get(URL + `/${params.partner_id}/videos`, { params: params }))
  return list
}

export const find = async (params) => {
  let one = null
  if (params.id) {
    one = (await http.get(URL + `/${params.partner_id}/videos/${params.id}`))
  }
  return one
}

export const save = (payload) => {
  let id = payload.id || ''
  return http.post(URL + `/${payload.partner_id}/videos/${id}`, payload)
}

export const deleteStreaming = async (payload) => http.delete(URL + `/${payload.partner_id}/videos/${payload.id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload.partner_id}/videos/${payload.id}/status`, payload)

export default {
  list,
  find,
  save,
  changeStatus,
  deleteStreaming
}
